import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';

class PlayerExclusionSwitcher extends Component {
    onCheck(isExcluded) {
        const {playerId, activeMode = Const.FLEX_MODE} = this.props;
        const list = {
            [activeMode]: {
                [playerId]: isExcluded,
            },
        };
        this.props.dispatch(Action.set('ExcludedPlayers', list));
    }

    render() {
        const {playerId, playersExclusion, activeMode = Const.FLEX_MODE, className = ''} = this.props;

        const isExcluded = playersExclusion.isExcluded(playerId, activeMode);

        return (
            <button
                type="button"
                className={`${className} checkbox-btn${!isExcluded ? ' active' : ''}`}
                onClick={() => ::this.onCheck(!isExcluded)}
                title={isExcluded ? 'Exclude enabled' : 'Exclude disabled'}
                data-testid="excluded-button"
            >
                {isExcluded ? 'Exclude enabled' : 'Exclude disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {playersExclusion} = state;
    return {
        playersExclusion,
    };
}

export default connect(mapStatesToProps)(PlayerExclusionSwitcher);
